import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=3f87c799&scoped=true"
import script from "./Events.vue?vue&type=script&lang=ts"
export * from "./Events.vue?vue&type=script&lang=ts"
import style0 from "./events.css?vue&type=style&index=0&id=3f87c799&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f87c799",
  null
  
)

export default component.exports